
import { defineComponent, reactive, ref } from "vue";
import { checkSmsCode, createUser, sentEmailOrPhoneCode } from "@/api/login";
import phoneAreaCode from "@/utils/areaCode";
import { Message } from "element-ui";
import { checkPhoneExist } from "@/api/user";
import useVerificationCode from "@/hooks/useVerificationCode";
import { useI18n } from "vue-i18n-composable";

const checkRightPhone = (phone) => {
  return /^1[123456789]\d{9}$/.test(phone);
};

const checkRightPassword = (password) => {
  return /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8}$/.test(
    password
  );
};

export default defineComponent({
  name: "RegisterForm",
  setup: (_props, { emit }) => {
    const { t } = useI18n();

    const registerForm = reactive({
      phone: "",
      code: "",
      password: "",
      passwordConfirm: "",
      areaNumber: "+86",
    });

    const { getVerificationCode, isGetting, codeText } =
      useVerificationCode(sentEmailOrPhoneCode);

    const isAgree = ref(true);

    const registerFormRef = ref();

    const password = (_rule, value, callback) => {
      if (!checkRightPassword(value)) {
        callback(new Error(<string>t("login.PleaseEnterPasswordTipCondition")));
      } else {
        callback();
      }
    };

    const passwordConfirm = (_rule, value, callback) => {
      if (value !== registerForm.password) {
        callback(new Error(<string>t("login.ConsistentPasswordTip")));
      } else {
        callback();
      }
    };

    const registerFormRules = {
      phone: [
        { required: true, message: t('login.TheMobilePhoneNumberFormatIsIncorrect'), trigger: "change" },
      ],
      code: [
        { required: true, message: t("login.PleaseEnterTheCorrectVcode"), trigger: "change" },
      ],
      password: [{ validator: password, trigger: "change" }],
      passwordConfirm: [{ validator: passwordConfirm, trigger: "change" }],
    };

    const handleGetCode = async () => {
      const { phone } = registerForm;

      const CHINA_AREA_CODE = "+86";
      if (
        registerForm.areaNumber === CHINA_AREA_CODE &&
        !checkRightPhone(phone)
      ) {
        return Message.error(t("login.TheMobilePhoneNumberFormatIsIncorrect") as string);
      }

      const { exist } = await checkPhoneExist(
        registerForm.phone,
        registerForm.areaNumber
      );
      if (exist) return Message.warning(t('login.heMobilePhoneNumberAlreadyExistsPleaseLogInDirectly') as string);

      getVerificationCode(phone, registerForm.areaNumber);
    };

    const handleRegister = () => {
      registerFormRef.value.validate(async (valid) => {
        if (valid) {
          const { phone, code, passwordConfirm } = registerForm;
          if (!isAgree.value) {
            return Message.error("请同意《签泰隐私协议》");
          }
          const { success } = await checkSmsCode(
            phone,
            code,
            registerForm.areaNumber
          );
          if (success) {
            // 验证码正确 创建用户
            const { isSuccess } = await createUser({
                phone,
                password: passwordConfirm,
                areaCode: registerForm.areaNumber
            });
            if (isSuccess) {
              Message.success("注册成功");
              emit("handleGoLogin");
            } else if (!isSuccess) {
              Message.error("该手机号已注册");
            }
          }
        }
      });
    };

    const handleClickMenu = (command) => {
      registerForm.areaNumber = command;
    };

    return {
      registerForm,
      registerFormRef,
      registerFormRules,
      isAgree,
      handleRegister,
      handleClickMenu,
      phoneAreaCode,
      isGetting,
      codeText,
      handleGetCode,
    };
  },
});
